/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
import classNames from 'classnames'
import { useField } from 'remix-validated-form'
import { twMerge } from 'tailwind-merge'
import { FormInputWrapperProps } from './FormInputWrapper'

type FormInputProps = {
  readOnly?: boolean
  labelClassName?: string
  checkboxClassName?: string
  errorClassName?: string
  defaultChecked?: boolean
} & FormInputWrapperProps<HTMLInputElement>

export default function FormCheckBox({
  label,
  name,
  readOnly,
  labelClassName,
  checkboxClassName,
  errorClassName,
  ...props
}: FormInputProps) {
  const { error, getInputProps } = useField(name, {
    validationBehavior: { initial: `onSubmit`, whenTouched: `onSubmit`, whenSubmitted: `onSubmit` },
  })

  return label ? (
    <>
      <label
        htmlFor={name}
        className={classNames(
          `inline-flex items-center text-body-sm`,
          props.disabled ? `text-minimal` : `text-default`,
          labelClassName,
        )}
      >
        <input
          {...getInputProps({
            ...props,
            type: `checkbox`,
            readOnly,
          })}
          id={name}
          defaultChecked={props.defaultChecked}
          className={twMerge(
            `mr-1.5 h-4 w-4 cursor-pointer rounded text-strong`,
            checkboxClassName,
            props.disabled && `border-strong checked:text-minimal`,
          )}
        />
        {label}
      </label>
      {error && <div className={twMerge(`mt-0.5 text-sm text-red-600`, errorClassName)}>{error}</div>}
    </>
  ) : (
    <>
      <input
        {...getInputProps({
          ...props,
          type: `checkbox`,
          readOnly,
        })}
        id={name}
        defaultChecked={props.defaultChecked}
        className={twMerge(
          `h-4 w-4 cursor-pointer rounded text-strong`,
          checkboxClassName,
          props.disabled && `border-strong checked:text-minimal`,
        )}
      />
      {error && <div className={twMerge(`mt-0.5 text-sm text-red-600`, errorClassName)}>{error}</div>}
    </>
  )
}
